import { Injectable } from '@angular/core';
import { AppTokenService } from './app-token.service';
import { HttpHandlerService } from './http-handler.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JobService {

  _httpHandler: HttpHandlerService;
  _apiUrl = environment.apiUrl;
  _resourceEndPoint = 'jobs';

  constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
    this._httpHandler = httpHandler;
  }

  public GetAllList(params?: any): Observable<any> {
    let full_api_url = `${this._apiUrl}${this._resourceEndPoint}?pagelimit=${params?.length}&pageoffset=${params?.start}`
    if (params?.refresh) {
      full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
    }
    const request_option = this._httpHandler.prepareRequest(
      'GET',
      full_api_url,
      {}
    );
    return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
  }

  public add(data: any): Observable<any> {
    const full_api_url = `${this._apiUrl}${this._resourceEndPoint}`;
    const request_options = this._httpHandler.prepareRequest(
      'POST',
      full_api_url,
      data
    );
    return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
  }

  public GetByGuid(guid: any): Observable<any> {
    const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/status`;
    const request_options = this._httpHandler.prepareRequest(
      'POST',
      full_api_url,
      guid
    );
    return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
  }

}
